import { StatCard } from './StatCard';
import { TestResultsChart } from './TestResultsChart';
import { LatestTestTable } from './LatestTestTable';
import type { TestResultsPoint } from './TestResultsChart';
import type { LatestTestRow } from './LatestTestTable';

interface DashboardOverviewProps {
  metrics: {
    totalTests: number;
    averageRT: number;
    medianRT: number;
  };
  chartData: TestResultsPoint[];
  latestTests: LatestTestRow[];
}

export function DashboardOverview({
  metrics,
  chartData,
  latestTests,
}: DashboardOverviewProps) {
  const hasResults = metrics.totalTests > 0;

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <StatCard
          title="Completed tests"
          value={metrics.totalTests.toLocaleString()}
        />
        <StatCard
          title="Average RT"
          value={hasResults ? `${Math.round(metrics.averageRT)} ms` : '—'}
        />
        <StatCard
          title="Median RT"
          value={hasResults ? `${Math.round(metrics.medianRT)} ms` : '—'}
        />
      </div>

      <div className="space-y-6">
        <TestResultsChart data={chartData} showXAxisLabels={false} />
        <LatestTestTable rows={latestTests} />
      </div>
    </>
  );
}
